<form [formGroup]="charityProfileFormGroup" class="profile-info-form">
    <h3 class="text-center">
        {{ "Charity Info" | translate }}
    </h3>
    <div class="text-center">
        <a
            class="text-secondary"
            href="javascript:void(0)"
            (click)="openDialog()"
            ><u>{{ "disclaimer question" | translate }}</u></a
        >
    </div>
    <p class="py-2 text-muted text-center">
        {{ "disclaimer" | translate }}
    </p>

    <div class="d-flex flex-column my-2">
        <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label> Charity/Non-Profit Name </mat-label>
            <input
                matInput
                placeholder="Enter name…"
                formControlName="charityName"
                fullNameDirective />
            <mat-error
                *ngIf="
                    charityProfileFormGroup
                        .get('charityName')
                        ?.hasError('required')
                ">
                Please enter your charity name.
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label> Charity/Non-Profit Number </mat-label>
            <input
                matInput
                placeholder="Enter number…"
                formControlName="charityNumber" />
            <mat-error
                *ngIf="
                    charityProfileFormGroup
                        .get('charityNumber')
                        ?.hasError('required')
                ">
                Please enter your charity number.
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w-100" color="accent">
            <mat-label>Business Rep Full Name</mat-label>
            <input
                matInput
                placeholder="Enter name…"
                formControlName="businessRepName"
                fullNameDirective />
            <mat-error
                *ngIf="
                    charityProfileFormGroup
                        .get('businessRepName')
                        ?.hasError('required')
                ">
                Please enter your business rep. name.
            </mat-error>
        </mat-form-field>
    </div>
    <address-section
        #addressSection
        (sectionChanged)="addressSectionValueChanges()"></address-section>
    <div class="d-flex">
        <button
            type="button"
            class="btn btn-primary rounded-pill text-light m-auto"
            matStepperNext
            [disabled]="!isFormValid"
            [ngClass]="
                isFormValid
                    ? 'btn-background-active'
                    : 'btn-background-inactive'
            "
            type="submit"
            (click)="onSubmit()">
            {{ "Continue" | translate }}
        </button>
    </div>
</form>
